import request from '@/modules/base/util/request'

import config from '../../../../modules/banking/config'
import pollTransaction from './pollTransaction'
import { generateProcessId, getProcessIdHeader } from '@/modules/banking/_helpers/generateProcessId'

const { urls } = config

// TODO
export const fetchLatestTurnoverForBankAccount = (bankAccountId, bankAccountInfo, processId) => {
  if (!processId) {
    processId = generateProcessId()
  }
  return new Promise((resolve, reject) => {
    request(urls.fetchLatestTurnoverForBankAccount(bankAccountId), {
      auth: true,
      isConcurrent: true,
      headers: {
        ...getProcessIdHeader(processId),
      },
    })
      .then(({ body: { data: transaction } }) => {
        return pollTransaction(transaction, null, processId)
      })
      .then(({ result }) => {
        resolve(result)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default fetchLatestTurnoverForBankAccount
